<template>
  <!-- #region template -->
  <b-container fluid class="table m-0" v-if="ready">
    <b-row>
      <!-- #region header -->
      <b-col cols="12" class="mb-3">
        <div class="d-flex justify-content-between align-items-center">
          <!-- #region title -->
          <div class="d-flex justify-content-between align-items-center" style="gap: 1.5rem">
            <h5 class="font-weight-medium m-0 text-dark">
              {{ options.title }}
            </h5>
            <template v-if="options.filters">
              <b-dropdown menu-class="text-nowrap" variant="link" toggle-class="text-decoration-none p-0" v-for="(filter, index) in options.filters" :key="index">
                <template #button-content>
                  <span>{{ filter.label }}</span>
                </template>
                <div class="p-3">
                  <b-form-checkbox-group @change="updateCollection" v-model="filter.selected" :options="filter.options" value-field="item" text-field="name" stacked disabled-field="notEnabled"></b-form-checkbox-group>
                </div>
              </b-dropdown>
              <b-button class="border" variant="light" v-on:click="resetFilters">Reset filters</b-button>
            </template>
          </div>
          <!-- #endregion -->
          <!-- #region actions -->
          <div class="d-flex justify-content-between align-items-stretch" style="gap: 1rem">
            <!-- #region search -->
            <!-- <b-form-group class="m-0">
              <b-input-group>
                <b-form-input id="filter-input" style="height: 37px" v-model="filter" type="search" placeholder="Search"></b-form-input>
              </b-input-group>
            </b-form-group> -->
            <!-- #endregion -->
            <!-- #region dropbown -->
            <b-dropdown class="border rounded" size="lg" style="height: 36px; width: 36px" variant="link" right toggle-class="text-decoration-none p-0 d-flex justify-content-center align-items-center" no-caret>
              <template #button-content>
                <b-icon icon="download" style="height: 14px; width: 16px"></b-icon>
              </template>
              <b-dropdown-item v-on:click="tableAction('export', items)" href="#">Export</b-dropdown-item>

              <b-dropdown-item v-on:click="tableAction('import', [])" href="#">Import</b-dropdown-item>
            </b-dropdown>
            <!-- #endregion -->
            <!-- #region add -->
            <b-button
              variant="primary"
              v-on:click="
                if (options.actions.add) {
                  tableAction('add', [])
                }
              "
              >New {{ capitalizeToLowercase(pluralToSingular(options.title)) }}</b-button
            >
          </div>
          <!-- #endregion -->
          <!-- #endregion -->
        </div>
      </b-col>
      <!-- #endregion -->
      <!-- #region table -->
      <b-col cols="12">
        <b-table class="bg-white border m-0" show-empty hover :items="items" :per-page="options.perPage" :fields="options.fields" :filter="filter" @filtered="onFiltered" :busy="busy" @row-clicked="myRowClickHandler">
          <template #empty>
            <div class="text-center my-2">
              <p>You don't have any {{ capitalizeToLowercase(options.title) }} yet. Try adding one by clicking on the "New {{ capitalizeToLowercase(pluralToSingular(options.title)) }}" button above.</p>
            </div>
          </template>
          <template #table-busy>
            <div class="text-center text-primary my-2">
              <b-spinner class="align-middle mr-2"></b-spinner>
            </div>
          </template>
          <template #table-colgroup="scope">
            <col v-for="field in scope.fields" :key="field.key" :style="{ width: field.width || 'auto' }" />
          </template>
          <template #head()="data">
            <p class="font-weight-medium m-0">{{ data.label }}</p>
          </template>
          <!-- #region cell -->
          <template #cell()="cell">
            <template v-if="cell.field.type == 'status'">
              <p class="m-0" :class="{ 'text-success': cell.value, 'text-warning': !cell.value }">{{ cell.value ? 'Published' : 'Draft' }}</p>
            </template>
            <template v-else-if="cell.field.type == 'timestamp'">
              {{ timestampToDate(cell.value) }}
            </template>
            <template v-else-if="cell.field.type == 'country'">
              {{ codeToCountry(cell.value) }}
            </template>
            <template v-else-if="cell.field.type == 'cardinal'">
              {{ GetCardinals(cell.value) }}
            </template>
            <template v-else-if="cell.field.type == 'multiselect'">
              {{ concatArrayValueByKey(cell.value, cell.field.refKey) }}
            </template>
            <template v-else-if="cell.field.type == 'number'"> {{ cell.field.prefix }}{{ formatToCurrency(cell.value) }} </template>
            <template v-else-if="cell.field.type == 'boolean'">
              <p :style="{ color: cell.value ? 'green' : 'orange' }">{{ cell.value ? cell.field.set : cell.field.unset }}</p>
            </template>
            <template v-else-if="cell.field.type == 'image'">
              <div class="d-flex justify-content-center">
                <div style="position: relative; height: 38px; width: 38px; background-color: #f0f0f0; border-radius: 4px" class="border d-flex justify-content-center align-items-center">
                  <img :src="getCellValue(cell)" style="height: 100%; max-width: 100%" />
                </div>
              </div>
            </template>
            <template v-else-if="cell.field.type == 'url'">
              <a target="_blank" :href="getCellValue(cell)">{{ getCellValue(cell) }}</a>
            </template>
            <template v-else>
              <!-- <div class="m-0" style="text-overflow: ellipsis; overflow: hidden; white-space: nowrap; width: 400px">{{ getCellValue(cell) }}</div> -->

              {{ getEllipsis(getCellValue(cell)) }}
              <!-- {{ getCellValue(cell) }} -->
            </template>
          </template>
          <template #cell(progress)="cell">
            <template v-for="(obj, index) in [getProgress(cell.item)]">
              <b-progress style="max-width: 300px" b-progress :value="obj.value" :variant="obj.variant" height="0.5rem" :key="index"></b-progress>
            </template>
          </template>
          <template #cell(actions)="cell">
            <!-- <b-form-checkbox id="checkbox-1" v-model="selectedEntries" :value="row.item.reference"> </b-form-checkbox> -->
            <b-dropdown size="lg" variant="link" right toggle-class="text-decoration-none p-0" no-caret>
              <template #button-content>
                <b-icon class="text-muted" icon="three-dots-vertical" aria-hidden="true"></b-icon>
              </template>
              <template v-if="options.actions.print">
                <b-dropdown-item size="sm" @click="tableAction('print', [cell.item])" class="mr-1">Print</b-dropdown-item>
              </template>
              <template v-if="options.actions.call">
                <b-dropdown-item :href="'tel:' + cell.item.phone" size="sm" class="mr-1">Call</b-dropdown-item>
              </template>
              <template v-if="options.actions.email">
                <b-dropdown-item :href="'mailto:' + cell.item.email" size="sm" class="mr-1">Mail</b-dropdown-item>
              </template>
            </b-dropdown>
          </template>
          <!-- #endregion -->
          <!-- #region caption -->
          <template #table-caption>
            <div class="w-100">
              <div class="d-flex justify-content-end" style="gap: 1rem">
                <b-button class="border rounded" :disabled="currentPage == 1" v-on:click="pageChangePrev">
                  <b-icon icon="chevron-left" style="height: 14px; width: 16px"></b-icon>
                </b-button>
                <b-button class="border rounded" v-on:click="pageChangeNext" :disabled="lastPage">
                  <b-icon icon="chevron-right" style="height: 14px; width: 16px"></b-icon>
                </b-button>
              </div>
            </div>
          </template>
          <!-- #endregion -->
        </b-table>
      </b-col>
      <!-- #endregion -->
      <!-- #region modals -->
      <!-- #region add -->
      <b-modal hide-footer ref="add-modal" size="xl" :title="'Add ' + capitalizeToLowercase(pluralToSingular(options.title))" body-class="p-5">
        <cForm
          @close="
            $refs['add-modal'].toggle()
            updateCollection()
          "
          type="add"
          :blueprint="options.blueprint"
          :init="documents[0]"
          :documents="items" />
      </b-modal>
      <!-- #endregion -->
      <!-- #region edit -->
      <b-modal hide-footer ref="edit-modal" size="xl" :title="'Edit ' + capitalizeToLowercase(pluralToSingular(options.title))" body-class="p-5">
        <cForm
          @close="
            $refs['edit-modal'].toggle()
            updateCollection()
          "
          @deleteEntry="$refs['remove-modal'].toggle()"
          type="edit"
          :blueprint="options.blueprint"
          :init="documents[0]"
          :documents="items" />
      </b-modal>

      <!-- #endregion -->
      <!-- #region remove -->
      <b-modal ref="remove-modal" header-bg-variant="danger" header-text-variant="light" :title="'Delete ' + capitalizeToLowercase(pluralToSingular(options.title))">
        <div>
          <p>You are about to delete the following documents from the collection:</p>
          <b-table :items="documents" :fields="[options.fields[0]]"></b-table>
          <p>Are you sure you want to continue? This action is irreversible.</p>
        </div>
        <template #modal-footer>
          <b-button variant="secondary" @click="$refs['remove-modal'].toggle()">Cancel</b-button>
          <b-button variant="danger" v-on:click="deleteConfirm">Delete</b-button>
        </template>
      </b-modal>

      <!-- #endregion -->
      <!-- #region import -->
      <b-modal hide-footer ref="import-modal" size="xl" :title="'Import ' + capitalizeToLowercase(pluralToSingular(options.title)) + 's'">
        <div>
          <p>You can import data to your collection here. The supported formats are JSON and CSV.</p>
          <b-form-group>
            <b-form-file @change="importDocuments($event)"></b-form-file>
          </b-form-group>
          <b-table :items="documents" :fields="options.fields"></b-table>
          <b-button variant="primary" v-on:click="applyImport">Import</b-button>
        </div>
      </b-modal>

      <!-- #endregion -->
      <!-- #region export -->
      <b-modal hide-footer ref="export-modal" size="xl" :title="'Export ' + capitalizeToLowercase(pluralToSingular(options.title)) + 's'">
        <div>
          <p>You can export your data to from your collection here. The supported formats are JSON and CSV.</p>
          <b-button variant="primary" :disabled="exporting" v-on:click="exportDocuments(EXPORT_TYPE.JSON)">Download JSON</b-button>
          <b-button variant="primary" class="ml-2" :disabled="exporting" v-on:click="exportDocuments(EXPORT_TYPE.CSV)">Download CSV</b-button>
          <!-- <b-button variant="primary" class="ml-2" :disabled="exporting" v-on:click="exportDocuments(EXPORT_TYPE.PRINT)">Print</b-button> -->
          <b-button variant="primary" class="ml-2" :disabled="exporting" v-on:click="exportDocuments(EXPORT_TYPE.TEMPLATE)">Download Template</b-button>
        </div>
      </b-modal>
      <!-- #endregion -->
      <!-- #endregion -->
    </b-row>
  </b-container>
  <!-- #endregion -->
</template>

<script>
// #region script
import cForm from '@/components/cForm'

import { mapState, mapActions } from 'vuex'
import { concatArrayValueByKey, documentTemplate, documentsToJSON, documentToCSV, csvToJSON, GetCardinals } from '@/utils'
import { getFirestore, query, where, endBefore, limitToLast, limit, startAfter, collection, getDocs, orderBy, getDoc, doc, setDoc, addDoc } from 'firebase/firestore'
import { getApp } from 'firebase/app'
import { formatToCurrency, timestampToDate, downloadTemplate, pluralToSingular, capitalizeToLowercase, byString, toJSON, toCSV, toPRINT, csvToJson, translateDataType, EXPORT_TYPE, IMPORT_TYPE, codeToCountry } from '@/utility' // TODO change this so that the import under methods works like Vuex mapActions ["functions", "functions"]

export default {
  name: 'wTable',
  components: {
    cForm,
  },
  props: {
    options: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      busy: true,
      filter: {},
      items: [],
      itemsClean: [],
      documents: [],
      EXPORT_TYPE,
      selectedEntries: [],
      exporting: false,

      // PAGINATION
      ready: false,
      db: undefined,
      collection: undefined,
      currentPage: 1,
      perPage: 5,
      startAfter: undefined,
      endBefore: undefined,
      lastPage: undefined,
    }
  },
  computed: {
    ...mapState(['settings']),
  },
  async created() {
    this.db = getFirestore(getApp('secondary'))
    this.options.filters?.forEach((filter) => {
      //TODO pagination . this is also where we need to build a smart system, so we don't have to load the entire collection before hand
      this['firestore/getDocs']({
        path: filter.collection.name,
      }).then((documents) => {
        filter.options = []
        filter.selected = []
        documents.forEach((value) => {
          filter.options.push({
            item: value._reference,
            name: value.name,
          })
        })
      })
    })
    try {
      this.collection = await getDoc(doc(this.db, '_collections', this.options.blueprint.collection))
      this.collection = this.collection.data()
      this.updateCollection()
      this.ready = true
    } catch (error) {}
  },
  methods: {
    concatArrayValueByKey,
    GetCardinals,
    ...mapActions(['deleteDocuments', 'addDocument', 'importDocument', 'getCollection', 'populateDocument', 'firestore/getDocs', 'firestore/addDoc']),
    // FROM HERE
    /**
     * Change to the previous page.
     * @async
     */
    async pageChangePrev() {
      this.busy = true
      this.currentPage--
      try {
        const querySnapshot = await this.prevPage()
        this.items = []
        querySnapshot.forEach((doc) => {
          let _doc = doc.data()
          _doc._id = doc.id
          this.items.push(_doc)
        })
        this.items = this.items.map((value) => {
          value.reference = `${this.options.blueprint.collection}/${value._id}`
          return this.populateDocument({
            document: value,
            maxDepth: 2,
          })
        })
        let res = await Promise.all(this.items)
        this.items = res
      } catch (error) {
        alert('Noget gik galt. Opdater venligst din browser og prøv igen!')
      }
      this.busy = false
    },
    /**
     * Change to the next page.
     * @async
     */
    async pageChangeNext() {
      this.busy = true
      try {
        this.currentPage++
        const querySnapshot = await this.nextPage()
        this.items = []
        querySnapshot.forEach((doc) => {
          let _doc = doc.data()
          _doc._id = doc.id
          this.items.push(_doc)
        })
        this.items = this.items.map((value) => {
          value.reference = `${this.options.blueprint.collection}/${value._id}`
          return this.populateDocument({
            document: value,
            maxDepth: 2,
          })
        })
        let res = await Promise.all(this.items)
        this.items = res
      } catch (error) {
        alert('No more pages')
      }
      this.busy = false
    },
    /**
     * Get the first page.
     * @async
     */
    async firstPage() {
      let _query = collection(this.db, this.options.blueprint.collection)
      if (this.options.orderBy) {
        _query = query(_query, orderBy(this.options.orderBy, 'desc'))
      }
      if (this.options.filters && this.options.filters[0].selected?.length) {
        _query = query(_query, where(this.options.filters[0].key, 'in', this.options.filters[0].selected))
      }
      _query = query(_query, limit(this.options.perPage))
      const querySnapshot = await getDocs(_query)
      if (this.options.perPage * this.currentPage > this.collection.totalRows) {
        this.lastPage = true
      } else {
        this.lastPage = false
      }
      this.startAfter = querySnapshot.docs[querySnapshot.docs.length - 1]
      return querySnapshot
    },
    /**
     * Get the next page.
     * @async
     */
    async nextPage() {
      let _query = collection(this.db, this.options.blueprint.collection)
      if (this.options.orderBy) {
        _query = query(_query, orderBy(this.options.orderBy, 'desc'))
      }
      _query = query(_query, startAfter(this.startAfter))
      if (this.options.filters && this.options.filters[0].selected?.length) {
        _query = query(_query, where(this.options.filters[0].key, 'in', this.options.filters[0].selected))
      }
      _query = query(_query, limit(this.options.perPage))
      const querySnapshot = await getDocs(_query)
      if (querySnapshot.docs.length) {
        this.startAfter = querySnapshot.docs[querySnapshot.docs.length - 1]
        this.endBefore = querySnapshot.docs[0]
        if (this.options.perPage * this.currentPage > this.collection.totalRows) {
          this.lastPage = true
        } else {
          this.lastPage = false
        }
        return querySnapshot
      } else {
        throw new Error('no next page')
      }
    },
    /**
     * Get the previous page.
     * @async
     */
    async prevPage() {
      let _query = collection(this.db, this.options.blueprint.collection)
      if (this.options.orderBy) {
        _query = query(_query, orderBy(this.options.orderBy, 'desc'))
      }
      _query = query(_query, endBefore(this.endBefore))
      if (this.options.filters && this.options.filters[0].selected?.length) {
        _query = query(_query, where(this.options.filters[0].key, 'in', this.options.filters[0].selected))
      }
      _query = query(_query, limit(this.options.perPage))
      const querySnapshot = await getDocs(_query)
      this.startAfter = querySnapshot.docs[querySnapshot.docs.length - 1]
      this.endBefore = querySnapshot.docs[0]
      this.lastPage = false
      return querySnapshot
    },
    /**
     * Updates the table. Sets it to the first page.
     * @async
     */
    async updateCollection() {
      this.busy = true
      try {
        const querySnapshot = await this.firstPage()
        this.items = []
        querySnapshot.forEach((doc) => {
          let _doc = doc.data()
          _doc._id = doc.id
          this.items.push(_doc)
        })
        this.items = this.items.map((value) => {
          value.reference = `${this.options.blueprint.collection}/${value._id}`
          return this.populateDocument({
            document: value,
            maxDepth: 2,
          })
        })
        let res = await Promise.all(this.items)
        this.items = res

        // this.items = this.items.map((value) => {
        //   value.reference = `${this.options.blueprint.collection}/${value._id}`
        //   return value
        // })
        // this.items = this.items.filter((value) => {
        //   return value.product.url
        // })
        this.currentPage = 1
      } catch (error) {
        alert('Noget gik galt. Opdater venligst din browser og prøv igen!')
      }
      this.busy = false
    },
    resetFilters() {
      this.isBusy = true
      this.options.filters.forEach((filter) => {
        filter.selected = []
      })
      this.filter = ''
      this.updateCollection()
      this.isBusy = false
    },
    // TO HERE
    pluralToSingular,
    capitalizeToLowercase,
    timestampToDate,
    translateDataType,
    codeToCountry,
    formatToCurrency,
    getEllipsis(string) {
      return string.length > 60 ? string.substr(0, 59) + '..' : string
    },
    getCellValue(cell) {
      return [cell.field.prefix, cell.value.toString(), cell.field.suffix].filter(Boolean).join('')
    },
    getViewLink(view, item) {
      let href = ''
      view.forEach((value) => {
        if (typeof value.prefix == 'string') {
          href += value.prefix
        } else {
          href += this.settings[value.prefix.key] + '/'
        }
        href += `${byString(item, value.key)}${value.suffix}`
      })
      return href
    },
    myRowClickHandler(record) {
      if (this.options.actions.edit) {
        this.tableAction('edit', [record])
      } else {
        this.$emit('openDocument', record)
      }
      /*
        this.$emit("openView", record, this.options.blueprint.view)
      */
    },
    getProgress(document) {
      let x = 0
      this.options.blueprint.form.tabs.forEach((tab) => {
        x += tab.elements.length
      })
      let y = 0
      this.options.blueprint.form.tabs.forEach((tab) => {
        tab.elements.forEach((element) => {
          if (document[element.key] != undefined) {
            y++
          }
        })
      })
      return {
        value: (y / x) * 100,
        variant: (y / x) * 100 == 100 ? 'success' : (y / x) * 100 >= 50 ? 'warning' : 'danger',
      }
    },
    tableAction(action, documents) {
      switch (action) {
        case 'add':
          this.documents = [{}]
          this.options.blueprint.form.tabs.forEach((tab) => {
            tab.elements.forEach((element) => {
              this.documents[0][element.key] = element.default
            })
          })
          this.$refs['add-modal'].toggle()
          break
        case 'edit':
          this.documents = documents
          this.$refs['edit-modal'].toggle()
          break
        case 'copy':
          this.documents = {
            ...documents,
          }
          delete this.documents[0].reference
          this.$refs['add-modal'].toggle()
          break
        case 'remove':
          this.documents = documents
          this.$refs['remove-modal'].toggle()
          break
        case 'import':
          this.documents = documents
          this.$refs['import-modal'].toggle()
          break
        case 'export':
          this.documents = documents
          this.$refs['export-modal'].toggle()
          break
        case 'print':
          toPRINT(documents, this.options)
          break
        default:
          break
      }
    },
    async exportDocuments(exportType) {
      //prevent multi click on button
      this.exporting = true
      if (exportType == EXPORT_TYPE.TEMPLATE) {
        documentTemplate(this.options.blueprint)
      } else {
        this['firestore/getDocs']({
          path: this.options.blueprint.collection,
        }).then((documents) => {
          switch (exportType) {
            case EXPORT_TYPE.JSON:
              documentsToJSON(documents, this.options.blueprint)
              break
            case EXPORT_TYPE.CSV:
              documentToCSV(documents, this.options.blueprint)
              break
            case EXPORT_TYPE.PRINT:
              toPRINT(documents, this.options)
              break
            case EXPORT_TYPE.TEMPLATE:
              break
            default:
              break
          }
          this.exporting = false
        })
      }
    },
    /**
     * TODO does not support multiselect and select (references yet), we need to decide how this should work
     * DOES NOT SUPPORT CHANGING OF DOCS
     */
    importDocuments(event) {
      let file = event.target.files[0]
      var reader = new FileReader()
      reader.readAsText(file, 'UTF-8')
      reader.onload = (event) => {
        let documents = event.target.result
        if (file.type == 'text/csv') {
          documents = csvToJSON(documents, this.options.blueprint)
        }
        if (file.type == 'application/json') {
          documents = JSON.parse(documents)
        }
        // TODO Task: Error Handling (unsupported file type) - Comment: Create an error handling view, that expects props, and render it here
        // documents = documents.map((document) => {
        //   this.options.blueprint.form.tabs.forEach((tab) => {
        //     tab.elements.forEach((element) => {
        //       if (document[element.key]) {
        //         if (element.type == 'select' && element.collection && document[element.key]) {
        //           document[element.key] = this.getDoc({
        //             reference: document[element.key],
        //           })
        //         }
        //         if (element.type == 'multiselect' && element.collection && document[element.key]) {
        //           document[element.key] = document[element.key].map((val) => {
        //             return this.getDoc({
        //               reference: val,
        //             })
        //           })
        //         }
        //       }
        //     })
        //   })
        //   return document
        // })
        this.documents = documents
      }
    },
    applyImport() {
      let values = []
      values.push(
        this['firestore/addDoc']({
          data: value,
          path: this.options.blueprint.collection,
        })
      )
      Promise.all(values)
        .then(() => {
          this.$refs['import-modal'].toggle()
        })
        .catch(() => {
          // TODO Task: Error Handling (firebase error) - Comment: Create an error handling view, that expects props, and render it here
        })
    },
    deleteConfirm() {
      this.deleteDocuments({
        documents: this.documents.map((document) => {
          return document.reference
        }),
      })
        .then(() => {
          this.$refs['remove-modal'].toggle()
          this.$refs['edit-modal'].toggle()
          this.updateCollection()
        })
        .catch(() => {
          // TODO Task: Error Handling (firebase error) - Comment: Create an error handling view, that expects props, and render it here
        })
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
  },
}
// #endregion
</script>

<style lang="scss">
// #region style
// TODO move into correct SCSS file
.border {
  border: 1px solid #ced4da !important;
}
.table thead th {
  vertical-align: bottom;
  border-bottom: none;
}
.table td {
  vertical-align: inherit;
  padding-top: 1rem;
  padding-bottom: 1rem;
}
caption {
  padding-bottom: 0;
}
.custom-control.custom-checkbox:not(:first-child) {
  margin-top: 0.5rem;
}
.dropdown-menu {
  padding: 0;
}
// #endregion
</style>
